import {useEffect, useState} from "react";
import getPage from "../../../helpers/getPage.helpers";

const QuestionAndAnswer = () => {
    const pageName = 'QA';

    const [content, setContent] = useState("");

    useEffect(() => {
        getPage(pageName).then((res) => res?.data?.content?.length && setContent(res?.data?.content))
    }, []);

    return (
      <div
        dangerouslySetInnerHTML={{
            __html: content
        }}
      />
    );
};

export default QuestionAndAnswer;
